const noop = require('mn-utils/noop');
const delay = require('mn-utils/delay');
const CancelablePromise = require('mn-utils/CancelablePromise');
const Emitter = require('mn-utils/Emitter');
const request = require('mn-utils/browser/request');
const blobToBase64Url = require('mn-utils/browser/blobToBase64Url');
const IMAGE_PDF = require('../assets/pdf.png');
const IMAGE_DOCX = require('../assets/docx.png');
const {
  openPopupError,
} = require('../emitters/popup');

export const MAX_LIMIT_MB = 25;
const SIZE_MB = 1024 * 1024;
const UPLOAD_LIMIT = SIZE_MB * MAX_LIMIT_MB - 1024 * 2;

export function checkByFileSize(file, maxFileSize, onError) {
  maxFileSize = maxFileSize || UPLOAD_LIMIT;
  if (file.size >= maxFileSize) {
    onError(new Error(`The file size exceeds the ${(maxFileSize / SIZE_MB).toFixed(2)} MB limit`));
    return true;
  }
  return false;
}


export function upload(url, data, options) {
  options = options || {};
  const progress$ = new Emitter(0);
  const onProgress = progress$.emit;
  const file = data.data || data.avatar;
  const fileType = file.type;
  return {
    progress$,
    promise: (new CancelablePromise((resolve, reject) => {
      if (checkByFileSize(file, options.maxFileSize, reject)) {
        return;
      }

      if (process.env.MOCK) {
        const size = 30;
        let index = 0;
        let _cancel = noop;
        function update() {
          onProgress(Math.floor(100 * index / size));
          index++;
          index < size
            ? (_cancel = delay(update, 200))
            : resolve({});
        }
        update();
        return () => {
          _cancel();
        };
      }

      const body = new FormData();
      let k;
      for (k in data) body.append(k, data[k]); // eslint-disable-line

      return resolve(request(url, {
        method: 'POST',
        body,
        onProgress,
      }));
    }))
        .then((response) => {
          const {
            error,
          } = response;
          if (error) {
            throw response.error;
          }
          return response.response;
        })
        .then((id) => {
          return CancelablePromise.resolve(
            /\/(jpe?g|png|bmp|gif|tiff)$/.test(fileType)
              ? blobToBase64Url(file)
              : (/word/.test(fileType) ? IMAGE_DOCX : IMAGE_PDF),
          )
              .then((url) => {
                return {
                  id,
                  url,
                };
              });
        })
        .finally((error) => {
          error && openPopupError(error.message);
        }),
  };
}

export function uploadDocument(params) {
  const url = params.uploadUrl;
  const docType = params.docType;
  const data = {
    data: params.data,
  };
  docType && (data.doc_type = docType);
  return upload(url, data, {
    maxFileSize: params.maxFileSize,
  });
}
